import { readonly, ref } from 'vue'

// The publish bar owns the publish flow and its modals. Other surfaces (the
// command palette's admin republish action) ask it to open the review modal
// by bumping this counter; the bar watches it and runs its normal publish
// validation.
const requestCount = ref(0)

export const usePublishReviewRequest = () => {
  const requestPublishReview = () => {
    requestCount.value += 1
  }

  return { requestCount: readonly(requestCount), requestPublishReview }
}
